<template>
    <div class="position-list-box" @click="goToDetail()">
        <div class="position-info">
            <div class="img-wrap">
                <img :src="position.enterpriseLogo | avatar('company')" v-img-error-company alt="">
            </div>
            <div class="info-box">
                <div class="flex-box">
                    <h2 class="pos-title line-clamp">{{position.positionTitle}}</h2>
                </div>
                <div class="flex-box mtb10 rel">
                    <div class="separate-info-list">
                        <span v-if="position.annualSalaryDesc">{{position.annualSalaryDesc}}万</span>
                        <span v-if="position.city">{{position.city}}</span>
                        <span v-if="position.degreeRequiredStr">{{position.degreeRequiredStr}}</span>
                        <span v-if="position.headCount">{{position.headCount}}人</span>
                    </div>
                </div>
                <p class="mtb10" style="font-size: 12px"><a href="#" class="light-gray">{{position.enterpriseName}}</a></p>
                <div class="flex-box">
                    <div class="stars-wrap">
                        <p>职位相似度</p>
                        <div class="star-rating">
                            <div class="star-rating-top" :style="'width:' + (position.matchScore*100).toFixed(1) + '%'">
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                            </div>
                            <div class="star-rating-bottom">
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <van-icon name="star" />
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                                <span><i class="iconfont icon-xing1"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="data-wrap">
                        <span class="data-list"><span class="green">{{position.matchCounts || 0}}</span>项匹配</span>
                        <span class="data-list"><span class="red">{{position.unMatchCounts || 0}}</span>项不符</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import PositionTags from "./positionTags";
  import {changeHomoReadStatus} from '@/api/aiMatch'

  export default {
    components: { PositionTags },
    props: {
        position: {
            default(){
                return {}
            }
        }
    },
    methods: {
        goToDetail(){

            // changeHomoReadStatus({homoId: this.position.homoId}).then(res=>{

            // }).catch(err=>{})

            // let url = `/positions/detail/${this.position.positionId}`;
            let talentId = '';
            if(this.$route.name == 'recommendDetail'){
                talentId = this.$route.query.talentId;
            }
            if(this.$route.name == 'matchDetail'){
                talentId = this.$route.params.sourceId;
            }
            // if(talentId){
            //     url = url + '?talentId=' + talentId;
            // }

            let params = {}
            if(talentId){
                params.talentId = talentId;
            }
            if(this.position.homoId){
                params.homoId = this.position.homoId;
            }

            this.$router.push({name: 'detail', params: {positionId: this.position.positionId}, query: {...params}});
        }
    }
  };
</script>

<style scoped lang="scss">
    .position-list-box {
        background-color: #fff;
        margin-bottom: 10px;
        padding: 10px 15px;
        .position-info {
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            .img-wrap{
                border-radius: 4px;
            }
            .info-box{
                flex: 1;
            }
            .pos-title {
                font-size: 16px;
                color: #333;
                &:hover,&:active,&:visited{
                    color: #22BAA5;
                }
            }
            .mtb10{
                line-height: 1;
            }
            .stars-wrap{
                flex: 1;
            }
            .data-wrap{
                margin-left: auto;
                display: flex;
                .data-list{
                    margin-left: 20px;
                    white-space: nowrap;
                }
            }
        }
    }
</style>
